import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import {
  IconComponent,
  LoaderWrapperComponent,
  ModalComponent,
  Button as ButtonComponent,
} from '../../../sharedLegacy/components'

import './SecondCameraModalComponent.scss'

const SecondCameraModalComponent = ({
  code,
  isLoading,
  shouldShow,
  onHide,
}) => {
  return (
    <ModalComponent
      showFooter
      footer={
        <ButtonComponent onClick={onHide}>
          <FormattedMessage defaultMessage="Done" />
        </ButtonComponent>
      }
      visible={shouldShow}
      wrapClassName="second-camera-modal-component"
      onCancel={onHide}
    >
      <LoaderWrapperComponent loading={isLoading}>
        <div className="icon-container">
          <div className="icon-wrapper">
            <IconComponent name="camera-plus" size={[24, 24]} color="fff" />
          </div>
        </div>
        <h1>
          <FormattedMessage defaultMessage="Add a 2ndCam" />
        </h1>
        <p>
          <FormattedMessage defaultMessage="Open this link in your mobile device's Safari browser and enter the code to use it as an additional camera on your webinar." />
        </p>
        <div className="join-code">{code}</div>
        <div className="link">https://twentythree.com/cam</div>
        <small>
          <FormattedMessage defaultMessage="The code will expire in 10 minutes" />
        </small>
      </LoaderWrapperComponent>
    </ModalComponent>
  )
}

SecondCameraModalComponent.propTypes = {
  code: PropTypes.string,
  shouldShow: PropTypes.bool,
  isLoading: PropTypes.bool,
  onHide: PropTypes.func,
}

export default SecondCameraModalComponent
